import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Box, Icon } from '@livable/saas-react-components';
import { Container, Typography, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material';
import React, { useState } from 'react';
import { BigInfoAlert } from 'src/components/general/BigAlerts';
import BatchFeeUpdateModal from 'src/components/fee/BatchFeeUpdateModal';
import ResidentModal from 'src/components/resident/ResidentModal';
import { buildingTenantsArray, tenantsArray } from 'src/configs/sampleData';
import useStyles from './styles';
const fees = [{
  address: '8558 Green Rd.',
  lateFee: '$5.00',
  insufficientFundsFee: '$5.00',
  accountMaintenance: '$5.00',
  vacancyCostRecovery: '$5.00',
  paperStatement: '$ 1.00',
  units: [{
    address: 'Unit NNN: Name Surname 1',
    lateFee: '$5.00',
    insufficientFundsFee: '$5.00',
    accountMaintenance: '$5.00',
    vacancyCostRecovery: '$5.00',
    paperStatement: '$ 1.00'
  }, {
    address: 'Unit NNN: Name Surname 2',
    lateFee: '$5.00',
    insufficientFundsFee: '$5.00',
    accountMaintenance: '$5.00',
    vacancyCostRecovery: '$5.00',
    paperStatement: '$ 1.00'
  }]
}, {
  address: '7529 E. Pecan St.',
  lateFee: '$5.00',
  insufficientFundsFee: '$5.00',
  accountMaintenance: '$5.00',
  vacancyCostRecovery: '$5.00',
  paperStatement: '$ 1.00'
}, {
  address: '775 Rolling Green Rd.',
  lateFee: '$5.00',
  insufficientFundsFee: '$5.00',
  accountMaintenance: '$5.00',
  vacancyCostRecovery: '$5.00',
  paperStatement: '$ 1.00'
}];
export default function FeeOverviewTab() {
  const classes = useStyles();
  const _useState = useState('overview'),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    tenantModalIsOpen = _useState4[0],
    setTenantModalIsOpen = _useState4[1];
  const openTenantModal = tab => {
    setActiveTab(tab);
    setTenantModalIsOpen(true);
  };
  const closeTenantModal = () => setTenantModalIsOpen(false);
  const batchFeeUpdateTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "action",
    'custom-attribute': '537-fee-structure-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coins-in-hand"
  }), "Batch fee update");
  const feeUpdateIconTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    'custom-attribute': '538-fee-structure-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BigInfoAlert, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Here is an overview of the active fees"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "When adding a new property to the system, a fee structure is set up for every unit enrolled in billing. However, you may also set a unique fee for each unit. Here is displayed the currently active fees and any individual unit overrides set up. You may either change fees here or in property and unit settings. Fee changes are applied on the next billing cycle. Residents will be alerted of the upcoming fee changes right away when the new fee structure is set."), /*#__PURE__*/React.createElement(Link, {
    href: "/"
  }, "How are the fees assessed?")), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(BatchFeeUpdateModal, {
    trigger: batchFeeUpdateTrigger,
    buildingsList: buildingTenantsArray
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.feesTable
  }, /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "fees table",
    type: "fullWidth"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Building"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Late", /*#__PURE__*/React.createElement("br", null), " fee"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Insufficient", /*#__PURE__*/React.createElement("br", null), " funds fee"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Resident account", /*#__PURE__*/React.createElement("br", null), " maintenance"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Vacancy cost", /*#__PURE__*/React.createElement("br", null), " recovery"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Edit"))), /*#__PURE__*/React.createElement(TableBody, null, fees.map(fee => {
    var _fee$units;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: fee.address
    }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, fee.address)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      className: classes.smallCell
    }, fee.lateFee), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      className: classes.smallCell
    }, fee.insufficientFundsFee), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      className: classes.smallCell
    }, fee.accountMaintenance), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      className: classes.smallCell
    }, fee.vacancyCostRecovery), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      className: classes.smallCell
    }, /*#__PURE__*/React.createElement(BatchFeeUpdateModal, {
      trigger: feeUpdateIconTrigger,
      tenantsList: tenantsArray
    }))), (_fee$units = fee.units) === null || _fee$units === void 0 ? void 0 : _fee$units.map((unit, i) => {
      const isLast = fee.units.length === i + 1;
      return /*#__PURE__*/React.createElement(TableRow, {
        key: unit.address
      }, /*#__PURE__*/React.createElement(TableCell, {
        className: "".concat(classes.subCell, " ").concat(isLast ? classes.lastSubCell : '')
      }, unit.address), /*#__PURE__*/React.createElement(TableCell, {
        align: "right",
        className: classes.smallCell
      }, unit.lateFee), /*#__PURE__*/React.createElement(TableCell, {
        align: "right",
        className: classes.smallCell
      }, unit.insufficientFundsFee), /*#__PURE__*/React.createElement(TableCell, {
        align: "right",
        className: classes.smallCell
      }, unit.accountMaintenance), /*#__PURE__*/React.createElement(TableCell, {
        align: "right",
        className: classes.smallCell
      }, unit.vacancyCostRecovery), /*#__PURE__*/React.createElement(TableCell, {
        align: "right",
        className: classes.smallCell
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "actionIcon",
        size: "small",
        onClick: () => openTenantModal('fee'),
        'custom-attribute': '539-fee-structure-page'
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "edit"
      }))));
    }));
  })))), /*#__PURE__*/React.createElement(ResidentModal, {
    isOpen: tenantModalIsOpen,
    handleOpen: openTenantModal,
    handleClose: closeTenantModal,
    activeTab: activeTab,
    setActiveTab: setActiveTab
  })))));
}